<template>
    <div class="add-content-page" id="add-content-page">
        <app-header 
            :position="'fixed'"
            :top="'0px'"
            :background="'transparent'"
            @clickBack="$router.push('/video-editor')"
            @clickMenu="change_menu(context, true)"
        />
        <div class="add-content-page__title">
            Добавить
        </div>
        <div class="add-content-page__element element__1"
             :class="{'add-content-page__element-disabled':disabled.video}"
            @click="content_click_video(context)"
        >
            <div class="add-content-page__element-text">
                Видео
            </div>
        </div>

        <div class="add-content-page__element element__2"
             :class="{'add-content-page__element-disabled':disabled.text}"
            @click="content_click_text(context)"
        >
            <div class="add-content-page__element-text">
                Текст
            </div>
        </div>

        <div class="add-content-page__element element__3"
            @click="$router.push('/add-music')"
        >
            <div class="add-content-page__element-text">
                Музыка
            </div>
        </div>

        <transition 
            name="fade-overlay" 
            appear
            mode="out-in"
        >
            <app-overlay 
                v-if="overlay"
            />
        </transition>

        <transition 
            name="default-fade" 
            appear
            mode="out-in"
        >
            <app-popup-color 
                v-if="popup.value"
                :text="popup.text"
                :hint="popup.hint"
                @clickButton="close_popup(context)"
            />
        </transition>

        <transition 
            name="fade-menu" 
            appear
            mode="out-in"
        >
            <app-menu 
                v-if="menu"
                idLogoMenu="header-component__menu"
                @clickLink="change_menu(context, false)"
                @clickOutside="change_menu(context, false)"
            />
        </transition >

    </div>
</template>

<script>
    const AppHeader = () => import('@/components/header.vue')
    const AppOverlay = () => import('@/components/overlay.vue')
    const AppPopupColor = () => import('@/components/popups/popup-color.vue')
    const AppMenu = () => import('@/components/menu.vue')

    import content_mounted_hook from "@/views/add_content/modules/content_mounted_hook";
    import content_click_video from "@/views/add_content/modules/content_click_video";
    import content_click_text from "@/views/add_content/modules/content_click_text";
    import change_menu from "@/views/theme/modules/change_menu";
    import close_popup from "@/views/video_editor/modules/close_popup";

    export default {
        async mounted() {
          this.content_mounted_hook(this)
        },
        components: {
            AppHeader,
            AppOverlay,
            AppPopupColor,
            AppMenu
        },
        data() {
            return {
                context: this,
                menu: false,
                overlay: false,
                disabled: {
                  video: false,
                  text: false
                },
                popup: {
                    value: false,
                    text: '',
                    hint: ''
                }
            }
        },
        methods: {
          content_mounted_hook,
          content_click_video,
          content_click_text,
          change_menu,
          close_popup
        },
        computed: {
            entry() {
              return this.$store.getters['entry_video/entry']
            },
            main() {
                return this.$store.getters['main_videos/main']
            },
            ending() {
              return this.$store.getters['ending_video/ending']
            }
        }
    }
</script>

<style lang="less">
    .add-content-page {
        background-color: #2F1F4C;
        width: 100%;
        height: calc(var(--vh, 1vh) * 100);
        min-height: 560px;
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Bold.less';

    .add-content-page__title {
        font-size: 28px;
        line-height: 20px;
        font-family: 'Montserrat-Bold';
        color: #FFFFFF;
        margin-top: 48px;
        margin-bottom: 29px;
    }

    .add-content-page__element {
        max-width: 343px;
        width: 100%;
        margin-left: 16px;
        margin-right: 16px;
        margin-top: 16px;
        height: 126px;
        border-radius: 16px;
        cursor: pointer;
        position: relative;
        display: flex;
        align-items: center;
        background-position: center center;
        background-size: cover;
    }

    .add-content-page__element-disabled {
      opacity: .2;
      cursor: default;
    }

    .element__1 {
        background-image: url('../../assets/add-video.jpg');
       
    }

    .element__2 {
        background-image: url('../../assets/add-text.jpg');
    }

    .element__3 {
        background-image: url('../../assets/add-music.jpg');
        margin-bottom: 16px;
    }

    .add-content-page__element-text {
        position: absolute;
        left: 38px;
        font-size: 19px;
        color: #FFFFFF;
        line-height: 24px;
        font-family: 'Montserrat-Bold';
    }

    #add-content-page .overlay-component {
        opacity: .9;
    }
</style>